import { Component, inject } from '@angular/core';

import { DatePipe } from '@angular/common';
import { ModalService } from 'src/app/components/modals/modal.service';
import { FeaturesService } from 'src/app/components/plans/features.service';
import { UsernamePipe } from 'src/app/shared/pipes/username.pipe';
import { ComponentsService } from '../../services/components.service';
import { TemplateEditorService } from '../../services/template-editor.service';

@Component({
    selector: 'template-editor-toolbar',
    templateUrl: './template-editor-toolbar.component.html',
    styleUrls: ['./template-editor-toolbar.component.scss'],
    providers: [DatePipe],
    standalone: false
})
export class TemplateEditorToolbarComponent {

  protected isPublicationApprovalAvailable = false;
  private datePipe = inject(DatePipe);
  private usernamePipe = inject(UsernamePipe);

  constructor(private modalService: ModalService,
    public templateEditorFactory: TemplateEditorService,
    public componentsService: ComponentsService,
    private featuresService: FeaturesService) {
      this.isPublicationApprovalAvailable = this.featuresService.isFeatureAvailable(
        FeaturesService.FEATURE_PUBLICATION_APPROVAL
      );
    }

  confirmDelete() {
    this.modalService.confirmDanger('Are you sure you want to delete this Presentation?',
      null,
      'Delete Forever'
    ).then(() => {
      this.templateEditorFactory.deletePresentation();
    });
  }

  openSettings() {
    let page = this.componentsService.getCurrentPage();
    if (!page || page.type !== 'rise-template-share-settings') {
      this.componentsService.editComponent({ type: 'rise-template-share-settings' });
    }
  }

  getSavedTooltipText() {
    return `Saved ${this.datePipe.transform(
      this.templateEditorFactory.presentation.changeDate, 'MMM d yyyy h:mm a'
    )} by ${this.usernamePipe.transform(
      this.templateEditorFactory.presentation.changedBy
    )}`;
  }

}
